<template>
  <div>
    <v-app-bar density="compact" color="primary" fixed elevation="5">
      <v-app-bar-nav-icon size="small" @click="toggleNav()" class="ml-1"></v-app-bar-nav-icon>
      <v-app-bar-title class="text-h5">Destination Pet Admin</v-app-bar-title>
      <v-spacer></v-spacer>
      <span>{{ userName }}</span>
      <v-menu @update:modelValue="handleMenuClick" :model-value="state.open">
        <template v-slot:activator="{ props }">
          <v-btn icon size="small" v-bind="props" aria-expanded="false" class="pl-3">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list class="bg-primary">
          <v-list-item v-for="(item, index) in state.items" :key="index" :value="index" @click="item.action">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'Appbar',
  props: {
    userName: String,
  },
  emits: ['toggleNav', 'openNav'],
  setup(props, { emit }) {
    const router = useRouter()

    function toggleNav(): void {
      this.$emit('toggleNav')
    }

    const handleMenuClick = (value: boolean) => {
      state.open = value
    }

    const handleLogout = () => {
      localStorage.removeItem('identityToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('resources')
      state.open = false
      emit('openNav')
      router.push('/login')
    }

    const state = reactive({
      items: [
        { title: 'Logout', action: handleLogout },
      ],
      open: false,
    })

    return { state, toggleNav, handleLogout, handleMenuClick }
  },
})
</script>

